/**
 * Configuration for API-related settings, including the base URL.
 * The `apiUrl` is defined based on an environment variable (`REACT_APP_API_URL`)
 * to allow easy adjustment between development, staging, and production environments.
 * Defaults to 'http://localhost:5000/api' if the environment variable is not set.
 */
const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
};

export default config;
